var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3OfText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4037_35801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5566 4.93563L13.9975 3.49479C14.0381 3.45422 14.0704 3.40602 14.0924 3.35297C14.1144 3.29992 14.1257 3.24306 14.1257 3.18563C14.1257 3.1282 14.1144 3.07134 14.0924 3.01828C14.0704 2.96523 14.0381 2.91704 13.9975 2.87646L12.621 1.5",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 14.5607V4.06067C2.75 3.82861 2.84219 3.60604 3.00628 3.44195C3.17037 3.27786 3.39294 3.18567 3.625 3.18567C3.625 3.18567 10.3223 3.18567 13.9792 3.18567",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.992L2.44083 14.4323C2.48146 14.4729 2.5297 14.5052 2.58281 14.5272C2.6359 14.5492 2.69282 14.5605 2.75029 14.5605C2.80777 14.5605 2.86468 14.5492 2.91778 14.5272C2.97088 14.5052 3.01912 14.4729 3.05975 14.4323L4.5 12.9915",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 14.5607C13.482 14.5607 13.7046 14.4685 13.8687 14.3044C14.0328 14.1403 14.125 13.9177 14.125 13.6857",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.5607H10.625",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.875 14.5607H8",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 14.5607H5.375",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 11.9357V11.0607",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 9.31067V8.43567",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 6.68567V5.81067",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4037_35801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3OfText);
export default __webpack_public_path__ + "static/media/icon3OfText.12562ba150197badef8b8fe4816355f1.svg";
export { ForwardRef as ReactComponent };